import { FetchUtil } from "../util/FetchUtil";
import { HealioErrorModal } from "../components/healioGlobal/HealioErrorModal"
import { ICreateTranscript } from "../models/Transcript/ICreateTranscript";
import { ITranscriptEndpoint } from "../models/Transcript/ITranscriptEndpoint";
import { StringUtil } from "../util/StringUtil";

interface IEmailTranscriptRequest {
  DatasourceId: string;
  Email: string;
  FileName: string;
}

interface ICreateTranscriptRequest {
  TranscriptBody: string;
}

interface ICreateTranscriptResponse {
  readonly Error?: string;
  readonly PdfUrl?: string;
  readonly FileName?: string;
}

export class TranscriptService {
  constructor(private readonly _api: ITranscriptEndpoint) {}

  public async emailTranscript(
    datasourceId: string,
    transcript: ICreateTranscript,
    email: string
  ): Promise<void> {
    const api = this._api;
    const endpoint = api ? api.email : null;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint");
    }

    if (!transcript) {
      throw new Error("Invalid request");
    }

    const values = {
      email,
      encodedEmail: encodeURIComponent(email),
      encodedFilename: encodeURIComponent(transcript.filename),
      filename: transcript.filename,
    };

    const url = StringUtil.supplant(endpoint.url, values);
    if (!url) {
      throw new Error("Invalid endpoint");
    }

    const body: IEmailTranscriptRequest = {
      DatasourceId: datasourceId,
      Email: email,
      FileName: transcript.filename,
    };

    return void FetchUtil.sendMessage(
      {
        method: endpoint.method,
        url,
      },
      body
    );
  }

  public async createTranscript(html: string): Promise<ICreateTranscript | null> {
    const api = this._api;
    const endpoint = api ? api.generate : null;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint");
    }

    const body: ICreateTranscriptRequest = {
      TranscriptBody: (html || "").trim(),
    };

    let raw;
    try {
      raw = await FetchUtil.sendMessage(endpoint, body);
    } catch {
      raw = undefined;
    }

    if (typeof raw !== "object") {
      const msg = "Unexpected response from server";
      console.warn(msg, raw);
      HealioErrorModal.triggerHealioErrorModalEvent();
      return null;
    }

    const response = raw as ICreateTranscriptResponse;

    if (response.Error) {
      console.error(response.Error);
      HealioErrorModal.triggerHealioErrorModalEvent();
      return null;
    }

    if (response.PdfUrl && response.FileName) {
      return {
        filename: response.FileName,
        pdfUrl: response.PdfUrl,
      };
    }

    HealioErrorModal.triggerHealioErrorModalEvent();
    return null;
  }



}
